import { render, staticRenderFns } from "./EditMetalPlace.vue?vue&type=template&id=50a45293&scoped=true&"
import script from "./EditMetalPlace.vue?vue&type=script&lang=js&"
export * from "./EditMetalPlace.vue?vue&type=script&lang=js&"
import style0 from "./EditMetalPlace.vue?vue&type=style&index=0&id=50a45293&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a45293",
  null
  
)

export default component.exports